var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSaveIcon = function SvgSaveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.946 19.931a.618.618 0 0 1-.642-.045.641.641 0 0 1-.304-.563V5.352c0-.36.135-.676.406-.946.27-.27.585-.406.946-.406h9.915c.36 0 .676.135.946.406.27.27.406.585.406.946v13.97c0 .24-.102.429-.305.564a.618.618 0 0 1-.642.045l-5.363-2.298-5.363 2.298Z",
    fill: "#8F8F9B"
  })));
};
export default SvgSaveIcon;